if (typeof Mashie === "undefined") Mashie = {};
if (typeof Mashie.Controls === "undefined") Mashie.Controls = {};
if (typeof Mashie.Common === "undefined") Mashie.Common = {};
if (typeof Mashie.TranslateMode === "undefined") Mashie.TranslateMode = false;
